import{jsx as r}from"react/jsx-runtime";import{Stack as t,mergeStyleSets as e,hiddenContentStyle as o}from"@fluentui/react";const i=({children:i,when:n,...s})=>r(t,{...s,styles:e({root:n?o:void 0},s.styles),children:i});export{i as HideStack};
//# sourceMappingURL=HideStack.js.map
